// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"d974356b","297":"2592b16c","643":"40f435ef","660":"6505acba","787":"8fd3c773","959":"6e7c0f8d","971":"6e1b675f"}[chunkId] + ".chunk.js";
};